import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createSector,
  deleteSectorById,
  getSectorById,
  getSectorList,
  updateSectorById,
} from "./queries";

const SectorContext = createContext({});

export const useSectorContext = () => useContext(SectorContext);

export const SectorProvider = ({ ...props }) => {
  const [sectorList, setSectorList] = useState([]);
  const [sectorPerId, setSectorPerId] = useState({});

  const sectorListGetter = useCallback(async () => {
    try {
      const list = await getSectorList();
      setSectorList(list);
    } catch (e) {
      console.error("sectorListGetter", e);
      throw e;
    }
  }, []);

  const sectorByIdGetter = useCallback(
    async (id) => {
      try {
        setSectorPerId(await getSectorById(id));
      } catch (e) {
        console.error("sectorListGetter", e);
        throw e;
      }
    },
    [setSectorPerId]
  );
  const sectorCreate = useCallback(async (data) => {
    try {
      const sector = await createSector(data);
      setSectorList((old) => [...old, sector]);
    } catch (e) {
      console.error("sectorCreate", e);
      throw e;
    }
  }, []);
  const sectorUpdateById = useCallback(async (id, data) => {
    try {
      const updatedSector = await updateSectorById(id, data);
      setSectorPerId(updatedSector);
      setSectorList((old) =>
        old.map((elm) => (elm.id === updatedSector.id ? updatedSector : elm))
      );
    } catch (e) {
      console.error("sectorUpdateById", e);
      throw e;
    }
  }, []);

  const sectorDeleteById = useCallback(
    async (id) => {
      try {
        await deleteSectorById(id);
        setSectorList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("sectorDelete", e);
        throw e;
      }
    },
    [setSectorList]
  );
  const values = useMemo(
    () => ({
      sectorByIdGetter,
      sectorCreate,
      sectorDeleteById,
      sectorList,
      sectorListGetter,
      sectorPerId,
      sectorUpdateById,
      setSectorPerId,
    }),
    [
      sectorByIdGetter,
      sectorCreate,
      sectorDeleteById,
      sectorList,
      sectorListGetter,
      sectorPerId,
      sectorUpdateById,
      setSectorPerId,
    ]
  );
  return <SectorContext.Provider value={values} {...props} />;
};
